import { useLang } from '@/i18n';
import EfCardsAppB from '@elem/ui/ef-cards-app-b';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListB');
    const [listA, setListA] = useState([
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724231779594/a1-pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724231785487/a1-h5.png',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724138392232/a2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138168265/a2-h5.jpg',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724138413361/a3-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138417457/a3-h5.jpg',
            title: t('c_title'),
            desc: t('c_desc'),
        },
    ]);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            <EfCardsAppB type="noneOver" list={listA} />
        </div>
    );
}
